module.exports = __webpack_public_path__ + "static/img/10.d13dcac4.gif";